import classes from "@/templates/errors/view/styles.module.scss";
import { FastButton } from "@components/fastFields/fastButton";
import { IButtonModeEnum } from "@components/molecules/button";
import { routePath } from "@routes/path";
import type { IErrorCode, IErrorData } from "@/templates/errors/view/types";

export const frontErrors: Record<IErrorCode, IErrorData> = {
  500: {
    title: "errors.error500Front.title",
    description: "errors.error500Front.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"tryAgain"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.reload();
          }}
        />
        <FastButton
          type={"returnToMainPagePrimary"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </div>
    ),
  },
  400: {
    title: "errors.error400.title",
    description: "errors.error400.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"tryAgain"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.reload();
          }}
        />
        <FastButton
          type={"contact"}
          mode={IButtonModeEnum.Button}
          linkTo={routePath.support.home()}
        />
      </div>
    ),
  },
  404: {
    title: "errors.error404Front.title",
    description: "errors.error404Front.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"returnToMainPagePrimary"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </div>
    ),
  },
  403: {
    title: "errors.error403.title",
    description: "errors.error403.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"returnToMainPagePrimary"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </div>
    ),
  },
  503: {
    title: "errors.error503.title",
    description: "errors.error503.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"tryAgain"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.reload();
          }}
        />
        <FastButton
          type={"returnToMainPagePrimary"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </div>
    ),
  },
};

export const backErrors: Record<IErrorCode, IErrorData> = {
  500: {
    title: "errors.error500Back.title",
    description: "errors.error500Back.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"tryAgain"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.reload();
          }}
        />
        <FastButton
          type={"contact"}
          mode={IButtonModeEnum.Button}
          linkTo={routePath.support.home()}
        />
      </div>
    ),
  },
  400: {
    title: "errors.error400.title",
    description: "errors.error400.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"tryAgain"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.reload();
          }}
        />
        <FastButton
          type={"contact"}
          mode={IButtonModeEnum.Button}
          linkTo={routePath.support.home()}
        />
      </div>
    ),
  },
  404: {
    title: "errors.error404.title",
    description: "errors.error404.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"returnToMainPagePrimary"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </div>
    ),
  },
  403: {
    title: "errors.error403.title",
    description: "errors.error403.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"returnToMainPagePrimary"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </div>
    ),
  },
  503: {
    title: "errors.error503.title",
    description: "errors.error503.des",
    button: (
      <div className={classes.container__content__btns}>
        <FastButton
          type={"tryAgain"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.reload();
          }}
        />
        <FastButton
          type={"returnToMainPagePrimary"}
          mode={IButtonModeEnum.Button}
          onClick={() => {
            window.location.href = "/";
          }}
        />
      </div>
    ),
  },
};
